import React from 'react';
import { PaymentStatus } from '@apply/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCancel, faRefresh, faCheck } from '@fortawesome/free-solid-svg-icons';

interface PaymentFilterBoxParameters {
    set_paymentStatus: (status?: PaymentStatus) => void;
    paymentStatusType?: PaymentStatus;
    count: number;
    isActive: boolean;
}

export const PaymentFilterBox: React.FC<PaymentFilterBoxParameters> = ({
    set_paymentStatus,
    paymentStatusType,
    count,
    isActive,
}) => {
    let text = '';
    let className = '';
    let icon = undefined;

    switch (paymentStatusType) {
        case PaymentStatus.InProgress:
            text = 'In Progress';
            className = 'filter-box-gray';
            icon = faClock;
            break;
        case PaymentStatus.Failure:
            text = 'Failed';
            className = 'filter-box-red';
            icon = faCancel;
            break;
        case PaymentStatus.Refund:
            text = 'Refunded';
            className = 'filter-box-blue';
            icon = faRefresh;
            break;
        case PaymentStatus.Success:
            text = 'Succeeded';
            className = 'filter-box-green';
            icon = faCheck;
            break;
        default:
            text = 'All';
            className = 'filter-box-white';
            break;
    }

    if (!isActive) className += ' box-filter-inactive';

    return (
        <div
            className={className}
            onClick={() => set_paymentStatus(paymentStatusType)}
        >
            <div>{text}</div>
            <div>
                {icon && <FontAwesomeIcon icon={icon} />}
                &nbsp;
                <strong>{count.toString()}</strong>
            </div>
        </div>
    );
};
